import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { Task } from '@src/app/models/task';

@Injectable({
  providedIn: 'root'
})
export class CplListService {

  constructor(private http:HttpClient) { }
  taskDone(task:Task){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    const url = `${environment.apiUrl}/organization/${SessionHelper.getChoosenOrg()}/project/${task.projectId}/task/${task.taskId}/state`;
    return this.http.patch<any>(url, { taskstate: task.taskstate }, httpOptions);
  }
  taskUndone(task:Task){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    const url = `${environment.apiUrl}/organization/${SessionHelper.getChoosenOrg()}/project/${task.projectId}/task/${task.taskId}/state`;
    return this.http.patch<any>(url, { taskstate: task.taskstate }, httpOptions);
  }
}
